<template>
    <div class="tab-content">
        <slot></slot>
    </div>
</template>

<script type="text/babel">
export default {}
</script>
